import { z } from 'zod'

export const operatorGroupValidation = z.object({
  name: z.string().min(1, { message: 'Name must not be blank' }).max(50, { message: 'Name must not be longer than 50 characters' }),
  desp: z.string().max(255, { message: 'Description must not be longer than 255 characters' }).optional(),
  remarks: z.string().max(255, { message: 'Remarks must not be longer than 255 characters' }).optional(),
  operatorIds: z.array(z.object({
    value: z.string(),
    label: z.string(),
  })).min(1, { message: 'Must select at least one operator' }),
  divisionIds: z.array(z.object({
    value: z.string(),
    label: z.string(),
  })).min(1, { message: 'Must select at least one division' }),
  roleIds: z.array(z.object({
    value: z.string(),
    label: z.string(),
  })).min(1, { message: 'Must select at least one role' }),
})

export type OperatorGroupsValidation = z.infer<typeof operatorGroupValidation>
